import { ProfileCard } from "../../components/ProfileCard";
import "../../styles/Home.css";
import { ReactComponent as StreakIcon } from "../../images/fire.svg";
import { ReactComponent as LeagueIcon } from "../../images/shield.svg";
import { ReactComponent as ChallengesIcon } from "../../images/flag.svg";
import { ReactComponent as XPIcon } from "../../images/tick.svg";
import { useData } from "../../providers/ContextProvider";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Pie, Bar } from "react-chartjs-2";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

function Home() {
  const { state, dispatch } = useData();
  const { userStats, goals, scores } = state;

  function createPieChartLabels(goals) {
    return goals.map((goal) => goal.habitName);
  }

  function getLabelValues(scores) {
    return [18, 82];
  }

  const pieData = {
    labels: createPieChartLabels(goals),
    datasets: [
      {
        label: "# of Votes",
        data: getLabelValues(scores),
        backgroundColor: ["rgba(255, 99, 132, 0.8)", "rgb(85, 210, 199, 0.8)"],
        borderColor: ["rgba(0, 0, 0, 0)"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Weekly Progress",
      },
    },
  };

  function createBarChartLabels(scores) {
    return [
      "05-05-22",
      "06-05-22",
      "07-05-22",
      "08-05-22",
      "09-05-22",
      "10-05-22",
      "11-05-22",
    ];
  }

  const barData = {
    labels: createBarChartLabels(scores),
    datasets: [
      {
        label: "Reading",
        data: [10, 2, 10, 8, 2, 15, 7],
        backgroundColor: "rgba(255, 99, 132, 0.8)",
      },
      {
        label: "Coding",
        data: [20, 8, 40, 20, 6, 44, 20],
        backgroundColor: "rgb(85, 210, 199, 0.8)",
      },
    ],
  };

  return (
    <main className="home">
      <ProfileCard />
      <div className="dashboard">
        <div className="cards-container">
          <div className="card">
            <div>
              <StreakIcon className="card-icon" />
            </div>
            <div className="card-info">
              <div className="card-value">{userStats.currentStreak}</div>
              <div className="card-desc"> Day Streak</div>
            </div>
          </div>
          <div className="card">
            <div>
              <LeagueIcon className="card-icon" />
            </div>
            <div className="card-info">
              <div className="card-value">{userStats.currentLeague}</div>
              <div className="card-desc"> Current League</div>
            </div>
          </div>

          <div className="card">
            <div>
              <XPIcon className="card-icon" />
            </div>
            <div className="card-info">
              <div className="card-value">{userStats.XP}</div>
              <div className="card-desc"> Points Earned</div>
            </div>
          </div>

          <div className="card">
            <div>
              <ChallengesIcon className="card-icon" />
            </div>
            <div className="card-info">
              <div className="card-value">{userStats.challengesCompleted}</div>
              <div className="card-desc"> Challenges Completed</div>
            </div>
          </div>
        </div>
        <div className="graphs-container">
          <div className="graph-left">
            <div className="avg-section">
              <div className="avg-top">
                <div className="avg-right">Daily Average Points</div>
                <div className="avg-left">20</div>
              </div>
              <div className="avg-bottom">
                <span className="primary-color">5%</span> increase from
                yesterday
              </div>
            </div>
            <div className="pie-container">
              <Pie data={pieData} className="pie" />
            </div>
          </div>
          <div className="graph-right">
            <Bar options={options} data={barData} />
          </div>
        </div>
      </div>
    </main>
  );
}

export default Home;
